import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getFromInitialData } from 'utils/initial-data';
import { INITIAL_DATA_LOAD, INITIAL_DATA_LOAD_SUCCESS } from 'news/actions';
import { getIsFetched } from 'news/reducers';

function* loadInitialDatas() {
  const isFetched = yield select(getIsFetched);
  if (!isFetched) {
    // Images
    const strategy = yield call(getFromInitialData, 'strategy', null);
    const image = yield call(getFromInitialData, 'image', null);
    const catchStrategy = yield call(getFromInitialData, 'catchStrategy', null);
    const catchImage = yield call(getFromInitialData, 'catchImage', null);

    // Editorial
    const blocks = yield call(getFromInitialData, 'blocks', []);

    // Diffusion
    const targets = yield call(getFromInitialData, 'targets', []);

    yield put({
      type: INITIAL_DATA_LOAD_SUCCESS,
      targets,
      blocks,
      strategy,
      image,
      catchStrategy,
      catchImage,
    });
  }
}

export default function* root() {
  yield [takeLatest(INITIAL_DATA_LOAD, loadInitialDatas)];
}



// WEBPACK FOOTER //
// ./src/modules/news/sagas/index.js